<template>
  <nuttrema-layout-form-standard :edit="edit" :theme="theme">
    <template slot="center">
      <choose-subscription-plan theme="gray" :disabled="!edit"></choose-subscription-plan>
    </template>

    <template slot="footer">
      <nav class="level">
        <div class="level-left"></div>
        <div class="level-center w-50">
          <el-button
            type="nuttrema-dark-gray"
            class="w-100">
            {{ $t('label.proceed_to_checkout') }} <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
        <div class="level-right">
          <el-button
            type="text">
            {{ $t('label.cancel') }}
          </el-button>
        </div>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { assign } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';

import ChooseSubscriptionPlan from 'components/ui/subscription/cmpt-choose-subscription-plan';

export default {
  name: 'form-settings-subscription',
  props: {
    InstanceDetails: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    ChooseSubscriptionPlan,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {},
      originalData: {},
      rules: {
        name: [
          { required: true, message: 'Please input name', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const payload = this.getData();
          this.$emit('submit', this.toJSON(payload));
        }
        return valid;
      });
    },
    cancelChanges(formName) {
      this.edit = false;
      this.formData = assign({}, this.originalData);
      this.$nextTick(() => {
        this.$refs[formName].validate();
      });
    },
    toJSON(data) {
      return JSON.parse(JSON.stringify(data));
    },
    mapData() {},
    getData() {},
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/subscription/form-settings-subscription.vue